<template>
  <div id="freshgraduate">
    <!-- PC端 -->
    <div class="pc">
      <div class="ed" v-if="editFlag == 1">
        <my_dialogPc :myDialogData="dialogData" @handleClick="handleClick">
        </my_dialogPc>
      </div>
      <!-- 再一次进入时,只是展示却不能修改 -->
      <div class="onlyShow" v-else>
        <my_dialogPc :myDialogData="showdialogData" @handleClick="handleClick">
        </my_dialogPc>
      </div>
    </div>
  </div>
</template>

<script>
import * as freshgraduateData from "./freshgraduate.js";

export default {
  data() {
    return {
      flag: 0, //手机端和pc端切换
      editFlag: 0, // 0为进查看  1为编辑
      enrollId: "", // 资料ID
      dialogData: {
        flag: true,
        title: "应届毕业生资料申请填写",
        data: freshgraduateData.getfreshgraduateDialogData(),
        btns: [
          {
            active: "submit",
            btnName: "提交申请",
          },
        ],
        goBack: {
          active: "goBack",
          btnName: "返回",
        },
        statusCheckFile: [], //学籍资料审核表
        statusCheckFileName: "", //学籍资料审核表
        stuStatusFile: [], //所在学校学籍卡
        stuStatusFileName: "", //所在学校学籍卡
        idCardFile: [], //身份证正反面
        withoutTestFile: [], //免试(材料)
        withoutTestFileName: "", //免试(材料)
        otherScoreFile: [], //加分(材料)
        otherScoreFileName: "", //加分(材料)
        professionList: [], //报考专业
      },
      showdialogData: {
        flag: true,
        title: "应届毕业生资料申请查看",
        data: freshgraduateData.showfreshgraduateDialogData(),
        btns: [
          // {
          //   active: "submit",
          //   btnName: "提交申请",
          // },
        ],
        goBack: {
          active: "goBack",
          btnName: "返回",
        },
        statusCheckFile: [], //学籍资料审核表
        statusCheckFileName: "", //学籍资料审核表
        stuStatusFile: [], //所在学校学籍卡
        stuStatusFileName: "", //所在学校学籍卡
        idCardFile: [], //身份证正反面
        withoutTestFile: [], //免试(材料)
        withoutTestFileName: "", //免试(材料)
        otherScoreFile: [], //加分(材料)
        otherScoreFileName: "", //加分(材料)
        professionList: [], //报考专业
      },
      tJInfo: {},
    };
  },
  methods: {
    start() {
      if (window.screen.width / window.screen.height > 1) {
        this.flag = 1;
        this.judgment();
      } else {
        this.flag = 2;
        this.judgment();
      }
    },
    //查看学籍资格审核表
    getStatusCheckPath() {
      this.$request("post", "/getStatusCheckPath", null, (data) => {
        this.dialogData.data.forEach((element) => {
          if (element.key == "statusCheckFile") {
            console.log("查看学籍资格审核表", element);
            element.url = data.path;
            element.fujianName = data.name;
          }
        });
        this.getFingerpost();
      });
    },
    //查看指南
    getFingerpost() {
      this.$request("post", "/getFingerpost", null, (data) => {
        this.dialogData.data.forEach((element) => {
          if (element.key == "withoutTestFile") {
            element.url = data.fingerpostFile.data;
            // element.zhinan = data.fingerpostTxt;
          }
          if (element.key == 'changeType') {
            element.commonTxt = data.commonTxt; //非鼓励政策
            element.withoutTestTxt = data.withoutTestTxt; //加分
            element.otherScoreTxt = data.otherScoreTxt; //免试
          }
          if (element.key == 'proveFile') {
            element.fujianName = data.fingerpostFile.name;
          }

        });
      });
    },
    //获取报考专业
    getLabelList() {
      this.$request(
        "post",
        "/label/getLabelList",
        { type: "profession" },
        (data) => {
          let arr = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let obj = {
              label: element.content,
              value: element.content,
            };
            arr.push(obj);
          }
          this.dialogData.data.forEach((element) => {
            if (element.key == "readyProfession") {
              element.options = arr;
            }
          });
        }
      );
    },

    //进入页面根据资料id判断是(提交)还是(重提)
    judgment() {
      if (this.enrollId == "") {
        //资料id为空时是刚注册信息,带入注册时填写的信息
        this.dialogData.flag = true;
        this.showdialogData.flag = false;

        for (let index = 0; index < this.dialogData.data.length; index++) {
          const element = this.dialogData.data[index];
          if (element.key == "idCard") {
            element.value = sessionStorage.getItem("registrationidCard");
          }
          if (element.key == "phone") {
            element.value = sessionStorage.getItem("registrationphone");
          }
          if (element.key == "profession") {
            element.value = sessionStorage.getItem("registrationprofession");
          }
          if (element.key == "school") {
            element.value = sessionStorage.getItem("registrationschool");
          }
        }
      } else {
        //重提
        this.dialogData.flag = true;
        this.showdialogData.flag = false;
        let requestData = {
          flag: "1",
          studentId: sessionStorage.getItem("ID"),
        };
        // if (
        //   this.dialogData.data[6].value === this.dialogData.data[7].value
        // ) {
        //   this.$message.error("联系电话和紧急联系人电话不能相同!");
        //   return;

        // }

        this.$request("post", "/enrollInfo/getEnroll", requestData, (data) => {
          console.log("重新提交", data);
          if (data.special == null || data.special == "") {
            this.showdialogData.radio = "非鼓励政策"
          } else {
            this.showdialogData.radio = data.special;
          }

          this.tJInfo = data;
          for (let index = 0; index < this.dialogData.data.length; index++) {
            const element = this.dialogData.data[index];
            // if (element.key == "idCardFile" && data.idCardFile.length == 2) {
            //   // 身份证单独处理
            //   element.idcardImgLIst[0].path = data.idCardFile[0].path;
            //   element.idcardImgLIst[1].path = data.idCardFile[1].path;
            //   element.idcardImgLIst[0].pathflag = data.idCardFile[0].pathflag;
            //   element.idcardImgLIst[1].pathflag = data.idCardFile[1].pathflag;
            //   element.idCardflag = "1";
            // }
            element.value = data[element.key] ? data[element.key] : "--";
          }
          for (
            let index = 0;
            index < this.showdialogData.data.length;
            index++
          ) {
            const element = this.showdialogData.data[index];
            // if (element.key == "idCardFile" && data.idCardFile.length == 2) {
            //   // 身份证单独处理
            //   element.idcardImgLIst[0].path = data.idCardFile[0].path;
            //   element.idcardImgLIst[1].path = data.idCardFile[1].path;
            //   element.idcardImgLIst[0].pathflag = data.idCardFile[0].pathflag;
            //   element.idcardImgLIst[1].pathflag = data.idCardFile[1].pathflag;
            // }
            element.value = data[element.key] ? data[element.key] : "--";
          }

          // this.showdialogData.radio = data.special;
          // console.log("数据", this.showdialogData.radio);
          //存储全局加分面试的选项
          sessionStorage.setItem("generalRadio", data.special);
        });
      }
    },
    handleClick(active) {
      switch (active) {
        /* 提交申请 */
        case "submit":
          let requestData = {};
          //提交前先判断资料id是否为空
          //非空判断
          for (let index = 0; index < this.dialogData.data.length; index++) {
            const element = this.dialogData.data[index];
            /* 非空判断 */
            console.log("判断身份证照片", this.dialogData.data[6], element);

            if (
              !element.isNull &&
              (element.value == "" || element.value.length == 0)
            ) {

              //判断是非鼓励政策还是免试或者加分
              // if (
              //   this.dialogData.radio == "非鼓励政策" &&
              //   (element.key == "withoutTestFile" || element.key == "proveFile")
              // ) {
              //   console.log(9999);
              //   continue;
              // }
              if (
                this.dialogData.radio == "非鼓励政策" || this.dialogData.radio == null &&
                (element.key == "withoutTestFile" || element.key == "proveFile")
              ) {

                continue;
              }
              this.$message.error(element.name + "不可为空!");
              return;
            }
            // if (!element.isNull && element.fileList == 0) {
            //   this.$message.error(element.name + "不可为空!");
            //   return;
            // }
            // if (
            //   element.key == "idCardFile" &&
            //   element.idcardImgLIst[0].pathflag == "0"
            // ) {

            //   this.$message.error(element.name + "不可为空!");
            //   return;
            // }
            // if (
            //   element.key == "idCardFile" &&
            //   element.idcardImgLIst[1].pathflag == "0"
            // ) {


            //   this.$message.error(element.name + "不可为空!");
            //   return;
            // }

            //注册信息的时候,已经填写过注册信息了
            /* 手机号正确性合法性判断 */
            if (
              element.key == "phone" &&
              !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(
                element.value
              )
            ) {
              this.$message.error("请填写正确的联系电话!");
              return;
            }
            if (
              element.key == "contact" &&
              !this.$mobilePhoneNumberCheck.mobilePhoneNumberCheck(
                element.value
              )
            ) {
              this.$message.error("请填写正确格式的紧急联系人电话!");
              return;
            }
            /* 身份证号正确性合法性判断 */
            if (
              element.key == "idCard" &&
              !this.$idCardValidity.idCardValidity(element.value)
            ) {
              this.$message.error("请填写正确格式的身份证号!");
              return;
            }
            if (element.key == "idCardFile") {
              requestData.idCardFile = element.idcardImgLIst;
            } else {
              requestData[element.key] = element.value;
            }
          }
            requestData.id = this.enrollId;
            requestData.studentId = sessionStorage.getItem("ID");
            requestData.graduating = "1";
          // requestData.special = this.dialogData.radio;
          console.log(requestData);
          
          this.$confirm("材料一旦提交,不可更改,请仔细核对后提交", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "post",
                "/enrollInfo/subEnrollInfo",
                requestData,
                (data) => {
                  sessionStorage.setItem("enrollId", data.id);
                  this.$message({
                    type: "success",
                    message: "提交成功!",
                  });
                  sessionStorage.setItem("name", data.name);
                  this.$router.push("/dataRequest");
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消提交",
              });
            });

          break;
        case "goBack":
          if (this.editFlag == 1) {
            this.$confirm("返回后,填写的资料将不会被保存", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(() => {
                // this.$router.push("/dataRequest");
                if (this.enrollId == "") {
                  this.$router.push("/selectidentity");
                } else {
                  this.$router.push("/dataRequest");
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消返回",
                });
              });
          } else {
            this.$router.push("/dataRequest");
            // this.$router.push("/selectidentity");
          }

          break;

        default:
          break;
      }
    },
  },
  mounted() {
    this.editFlag = this.$route.query.flag;
    this.enrollId = sessionStorage.getItem("enrollId")
      ? sessionStorage.getItem("enrollId")
      : "";
    this.start();
    this.getLabelList();
    this.getStatusCheckPath();
  },
};
</script>

<style lang="less" scoped>
#freshgraduate {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .phone {
    width: 100%;
    height: 100%;
  }

  .pc {
    width: 100%;
    height: 100%;
    background: rgba(245, 245, 245, 1);

    .ed {
      width: 100%;
      height: 100%;
      background: rgba(245, 245, 245, 1);
    }

    .onlyShow {
      width: 100%;
      height: 100%;
      background: rgba(245, 245, 245, 1);
    }

    /deep/ .el-message-box__message {
      color: red;
    }
  }
}
</style>
